import { doorSettingsStateStore } from '../../../assets/scripts/service/redux-service';
import { loadDoorSettingsState } from '../../../assets/scripts/service/localStorage-service';
const aaecState = require('../../../json/state/aaec-state.json');
const regionsData = require('../../../json/regions.json');
const climateClassData = require('../../../json/climateclass.json');
const svgConfig = require('../../../json/svg.json');

export const sidepanelCustomize = (() => {

    let $doorHeightInput = $('input.door-height-value', '.customize-panel__grid');
    let $doorHeightValue = $(".door-height-value", '.customize-panel__grid');
    let $doorWidthInput = $('input.door-width-value', '.customize-panel__grid');
    let $doorWidthValue = $(".door-width-value", '.customize-panel__grid');
    let $doorNumberOfWindowPanelRadioButtons = $('input[type=radio][name=windows]', '.customize-panel__grid');
    let $doorOpeningFrequencyInput = $('input[type=radio][name=frequency]', '.customize-panel__grid');

    let $selectCountry = $('.select-country');
    let $selectRegion = $('.select-region');
    let $selectCurrency = $('.select-currency');
    let $climateClassName = $('.js-climate-class-name');
    let $climateClassDescription = $('.js-climate-class-description');
    let $climateClassIcon = $('.customize-panel__climate-icon span.svg');
    let $savingsPicker = $('.savings-picker');
    let $showMoney = $('.js-show-money');
    let $inputKwhPrice = $('.kwh-price');
    let $sidepanelCustomize = $('.sidepanel--customize');
    

    const $mobileButtonCloseCustomizePanel = $('.js-mobile-close-customize-btn');

    let doorState = aaecState;
    if (loadDoorSettingsState() !== undefined) {
        doorState = loadDoorSettingsState();
    }

    let unitLengthValue = " m";
    if (doorState.unit == "imperial") {
        unitLengthValue = " ft";
    }

    //=============================================================================================
    //=============================================================================================
    // HEIGHT
    // Update values on load after default state or if there is any state saved in local storage
    let doorHeightValue = doorState.door.properties.height;
    $doorHeightValue.text(doorHeightValue + unitLengthValue);
    $doorHeightInput.val(doorHeightValue).trigger('change');
    // On Slide
    $doorHeightInput.on('input change', function() {
        let unitLengthValue = " m";
        if (loadDoorSettingsState() !== undefined) {
            if (loadDoorSettingsState().unit == "imperial") {
                unitLengthValue = " ft";
            } else if (loadDoorSettingsState().unit == "metric") {
                unitLengthValue = " m";
            }
        }
        $(this).next('.range-slider__filler').addClass('focused'); // for glow
        $doorHeightValue.text($doorHeightInput.val() + unitLengthValue);
    });
    // On change
    $doorHeightInput.on('change', function() {
        doorSettingsStateStore.dispatch({ type: 'CHANGE_HEIGHT', height: $(this).val() });
        $('.range-slider__filler').removeClass('focused'); // for glow
    });

    //=============================================================================================
    //=============================================================================================
    // WIDTH
    // Update values on load after default state or if there is any state saved in local storage
    let doorWidthValue = doorState.door.properties.width;
    $doorWidthValue.text(doorWidthValue + unitLengthValue);
    $doorWidthInput.val(doorWidthValue).trigger('change');
    // Each time you drag the slider handle
    $doorWidthInput.on('input change', function() {
        let unitLengthValue = " m";
        if (loadDoorSettingsState() !== undefined) {
            if (loadDoorSettingsState().unit == "imperial") {
                unitLengthValue = " ft";
            } else if (loadDoorSettingsState().unit == "metric") {
                unitLengthValue = " m";
            }
        }
        $(this).next('.range-slider__filler').addClass('focused'); // for glow
        $doorWidthValue.text($doorWidthInput.val() + unitLengthValue);
    });
    // On change
    $doorWidthInput.on('change', function() {
        doorSettingsStateStore.dispatch({ type: 'CHANGE_WIDTH', width: $(this).val() });
        $('.range-slider__filler').removeClass('focused'); // for glow
    });

    //=============================================================================================
    //=============================================================================================
    // NUMBER OF WINDOW PANEL
    // Update values on load after default state or if there is any state saved in local storage
    $doorNumberOfWindowPanelRadioButtons.each(function(i) {
        if ($(this).val() == doorState.door.properties.numberOfWindowPanel) {
            $(this).prop('checked', true);
        } else {
            $(this).prop('checked', false);
        }
    });
    // On change
    $doorNumberOfWindowPanelRadioButtons.change(function() {
        doorSettingsStateStore.dispatch({ type: 'CHANGE_NUMBER_OF_WINDOW_PANEL', numberOfWindowPanel: $(this).val() })
    });

    //=============================================================================================
    //=============================================================================================
    // OPENING FREQUENCY
    // Update values on load after default state or if there is any state saved in local storage
    $doorOpeningFrequencyInput.each(function(i) {
        if ($(this).val() == doorState.door.properties.openingFrequency) {
            $(this).prop('checked', true);
        } else {
            $(this).prop('checked', false);
        }
    });
    // On change
    $doorOpeningFrequencyInput.change(function() {
        doorSettingsStateStore.dispatch({ type: 'CHANGE_OPENING_FREQUENCY', openingFrequency: $(this).val() })
    });

    //=============================================================================================
    //=============================================================================================
    // LOCATION ZONE
    // Continent
    // Populate Continent select box from regions data JSON file
    //var setLocation = '';
    //var setRegion = '';
    //console.log(location.hash);
    
    /*switch (location.hash) {
        case "#en":
            setLocation = "United Kingdom";
            setRegion = "All regions UK";
          break;
        case "#no-NO":
            setLocation = "Norway";
            setRegion = "Oslo";
          break;
        case "#da-DK":
            setLocation = "Denmark";
            setRegion = "Copenhagen";
          break;
        case "#de-DE":
            setLocation = "Germany";
            setRegion = "Berlin";
          break;
        default:
            setLocation = "United Kingdom";
            setRegion = "All regions UK";
      }*/

    $.each(regionsData.countries, function(i, item) {
        $selectCountry.append(
            $('<option>', {
                value: item.country,
                text: item.country
            }));
    });

    // Sets the Continent from doorState object as selected value
    /*$selectCountry.find('option').each(function() {
        if ($(this).text() == "Norway") {
            $selectCountry.val($(this).text());
        }
    });*/


    // City
    // Populate City select box from regions data JSON file depending on selected continent
    let result = regionsData.countries.find(item => item.country === $selectCountry.val());
    $.each(result.regions, function(i, item) {
        $selectRegion.append(
            $('<option>', {
                value: item.region,
                text: item.region
            }).attr('data-climate-zone-class', item.climate)
        );
    });
    // Sets the Continent from doorState object as selected value

    // On Contintent select box change get the cities from that continent from region data JSON file and run the action CHANGE_LOCATION_ZONE (redux) and send in continent city and climateZoneClass
    $selectCountry.on('change', function() {
        result = regionsData.countries.find(item => item.country === this.value);
        $selectRegion.empty();
        $.each(result.regions, function(i, item) {
            $selectRegion.append(
                $('<option>', {
                    value: item.region,
                    text: item.region
                }).attr('data-climate-zone-class', item.climate)
            );
        });
        doorSettingsStateStore.dispatch({ type: 'CHANGE_LOCATION_ZONE', country: $selectCountry.val(), region: $selectRegion.val(), climateZoneClass: $selectRegion.find(':selected').data('climate-zone-class') })
        //populateClimateClassInfoToDOM();
    });

    // On City select box change get run the action CHANGE_LOCATION_ZONE (redux) and send in continent city and climateZoneClass
    $selectRegion.on('change', function() {
        doorSettingsStateStore.dispatch({ type: 'CHANGE_LOCATION_ZONE', country: $selectCountry.val(), region: $(this).val(), climateZoneClass: $(this).find(':selected').data('climate-zone-class') })
        populateClimateClassInfoToDOM();
    });

    //Runs the climate code if the hash is changed (langauge)
    window.addEventListener('hashchange', function(e){
        populateClimateClassInfoToDOM();
        //$selectCountry.val(setLocation).trigger('change');
    })

    // Populate DOM climate class with text from climate Class json file depending on which climate class is chosen
    populateClimateClassInfoToDOM();

    function populateClimateClassInfoToDOM() {
        let currentLanguage = doorSettingsStateStore.getState().language;
        let climateZoneClass = $selectRegion.find(':selected').data('climate-zone-class');
        //old key climateZoneClass

        $climateClassName.text(climateClassData[currentLanguage].climateClasses[climateZoneClass].name);
        $climateClassDescription.text(climateClassData[currentLanguage].climateClasses[climateZoneClass].description);

        if (svgConfig.svg[climateZoneClass] !== undefined) {
            $climateClassIcon.html(svgConfig.svg[climateZoneClass]);
        } else {
            $climateClassIcon.html('');
        }
        //$selectCountry.val(setLocation).trigger('change');
    }

    $selectCurrency.append(
		$('<option>', {value: "EUR", text: "EUR", id: ""}),
        $('<option>', {value: "SEK", text: "SEK", id: "sv"}),
        $('<option>', {value: "NOK", text: "NOK", id: "noNO"}),
		$('<option>', {value: "DKK", text: "DKK", id: "daDK"})
	);
	
	if(doorSettingsStateStore.getState().savings != 'kWh'){
        $savingsPicker.prop('checked', true);  
    }

	$inputKwhPrice.val(doorSettingsStateStore.getState().price);

    checkSelectedSavings();

    $savingsPicker.on('click', function(e) {
        e.stopPropagation();
        checkSelectedSavings();
        $sidepanelCustomize.scrollTop($sidepanelCustomize[0].scrollHeight);
    });

    function checkSelectedSavings() {
		let savingsPickerValue = '';

        if ($savingsPicker.prop('checked')) {

			$showMoney.removeClass('hide');

			savingsPickerValue = $selectCurrency.val();
			
			doorSettingsStateStore.dispatch({ type: 'CHANGE_SAVINGS', savings: savingsPickerValue });
			
        } else {
			$showMoney.addClass('hide');
			
			savingsPickerValue = 'kWh';
			
			doorSettingsStateStore.dispatch({ type: 'CHANGE_SAVINGS', savings: savingsPickerValue });
			
        }
    }
    //Gets and set the clients energy price per kwh
    $inputKwhPrice.on('keyup', function() {


        let clientEnergyPrice = $(this).val().replace(/,/g, '.');

        delayKeyUp(function() {

            doorSettingsStateStore.dispatch({ type: 'CHANGE_PRICE', price: clientEnergyPrice });

        }, 1000);
	});
	
    //Makes sure that the price will only update each 1000ms so the app doesn't update during typing
    let delayKeyUp = (function() {
        let timer = 0;
        return function(callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        };
	})();
	
    //Changes currency
    $selectCurrency.on('change', function() {
		let clientCurrency = $(this).val();
		doorSettingsStateStore.dispatch({ type: 'CHANGE_SAVINGS', savings: clientCurrency });
    });

    //=============================================================================================
    //=============================================================================================
    // Update Input values
    // Using redux subscribe() method to update values in customize from door preset since that is the first choise in the application
    doorSettingsStateStore.subscribe(() => {
        let updatedDoorSettingsStateStore = doorSettingsStateStore.getState();
        let currentUnitValue = "";

        if (updatedDoorSettingsStateStore.unit == "imperial") {
            currentUnitValue = "ft";
        }
        if (updatedDoorSettingsStateStore.unit == "metric") {
            currentUnitValue = "m";
        }

        // HEIGHT
        if ($doorHeightInput.val() != updatedDoorSettingsStateStore.door.properties.height) {
            $doorHeightInput.val(updatedDoorSettingsStateStore.door.properties.height);
            $(".door-height-value", '.customize-panel__grid').text($doorHeightInput.val() + " " + currentUnitValue);
        }

        // WIDTH

        if ($doorWidthInput.val() != updatedDoorSettingsStateStore.door.properties.width) {
            $doorWidthInput.val(updatedDoorSettingsStateStore.door.properties.width);
            $(".door-width-value", '.customize-panel__grid').text($doorWidthInput.val() + " " + currentUnitValue);
        }


        // WINDOW PANELS
        $doorNumberOfWindowPanelRadioButtons.each(function(i) {
            if ($(this).val() == updatedDoorSettingsStateStore.door.properties.numberOfWindowPanel) {
                $(this).prop('checked', true);
            } else {
                $(this).prop('checked', false);
            }
        });
        // OPENING FREQUENCY
        $doorOpeningFrequencyInput.each(function(i) {
            if ($(this).val() == updatedDoorSettingsStateStore.door.properties.openingFrequency) {
                $(this).prop('checked', true);
            } else {
                $(this).prop('checked', false);
            }
        });
        //CONTINENT
        $selectCountry.find('option').each(function() {
            if ($(this).text() == updatedDoorSettingsStateStore.door.properties.locationZone.country) {
                $selectCountry.val($(this).text());
            }
        });
        // CITY
        let result = regionsData.countries.find(item => item.country === $selectCountry.val());
        $selectRegion.empty();
        $.each(result.regions, function(i, item) {
            $selectRegion.append(
                $('<option>', {
                    value: item.region,
                    text: item.region
                }).attr('data-climate-zone-class', item.climate)
            );
        });
        $selectRegion.find('option').each(function() {
            if ($(this).text() == updatedDoorSettingsStateStore.door.properties.locationZone.region) {
                $selectRegion.val($(this).text());
            }
        });

        // Turn the button in the fake-load div
        $('.js-icon-reload svg').addClass("spin-effect")
        setTimeout(function() {
            $('.js-icon-reload svg').removeClass("spin-effect");
        }, 500);

    });


    $mobileButtonCloseCustomizePanel.on('click', function() {
        if ($(window).width() <= 668) {
            $('.sidebar__link').removeClass('sidebar__link--active');
            $('.sidepanel, .modal, .preset-page, .overlay').removeClass('is--visible');
            $('.result-page').removeClass('result-page--is-compressed');
            $('.overlay').removeClass('is--visible');
            $('.mobile-close-customize-wrapper').hide();
        }
    });

})();


// WEBPACK FOOTER //
// ./src/components/sidebar-menu/sidepanel-customize/sidepanel-customize.js